export class CreditReason {
    public id : number = 0;
    public name : string = '';
    public defaultDescription : string = '';
    public revenueCode : string = '';
}